<template>
  <div class="wrapper">
    <!-- data Table -->
    <div>
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="d-flex justify-content-between align-items-center bg-secondary"
            >
              <h5 class="text-light m-0 p-0">گزارش</h5>
            </CCardHeader>
            <CCardBody>
              <div id="app" style="direction: ltr">
                <div>
                  <div id="viewer"></div>
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Values } from "../../commonValues";
const config = {
  timezone: "Asia/Tehran",
  locale: "en",
  fullTextFormat: "W, D N Y H:I:S",
  titleFormat: "W, D N Y",
  dateFormat: "Y-M-D",
  timeFormat: "H:I:S",
};

// Load modules
import { JalaliDateTime } from "jalali-date-time";
const jalali = JalaliDateTime(config);
export default {
  name: "app",
  props: ["whichReport", "chartData", "date", "sum"],

  data() {
    return {
      model: [],
    };
  },

  mounted() {
    if (localStorage.getItem("token"))
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;

    //console.log(this.$route.params.whichReport);
    if (this.$route.query.whichReport == "userList") {
      axios.get(Values.serverIp + "Report/GetUsers").then((response) => {
        this.setdata(response.data.reportList, response.data.dateTime);
        console.log(response.data);
      });
    } else if (this.$route.query.whichReport == "carList") {
      axios.get(Values.serverIp + "Report/GetCars").then((response) => {
        this.setdata(response.data.reportList, response.data.dateTime);
        console.log(response.data);
      });
    } else if (this.$route.query.whichReport == "deviceList") {
      axios.get(Values.serverIp + "Report/GetDevices").then((response) => {
        this.setdata(response.data.reportList, response.data.dateTime);
        console.log(response.data);
      });
    } else if (this.$route.query.whichReport == "sensorValue") {
      axios
        .post(
          Values.serverIp + "SensorValue/GetSensorValuesFromDateTimeToDateTime",
          {
            deviceId: this.$route.query.deviceId,
            sensorType: this.$route.query.sensorType,
            sensorIndex: this.$route.query.sensorIndex,
            fromDate: this.$route.query.fromDate,
            toDate: this.$route.query.toDate,
            fromTime: this.$route.query.fromTime,
            toTime: this.$route.query.toTime,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(jalali.now());
            //this.setdata(response.data.reportList, response.data.dateTime);
            this.setdata(
              response.data.reportData,
              jalali.now(),
              "",
              this.$route.query.sensorName
            );
          }
        });
    } else if (this.$route.query.whichReport == "paramValue") {
      axios
        .post(
          Values.serverIp +
            "LocationHistory/GetLocationValuesFromDateTimeToDateTime",
          {
            deviceId: this.$route.query.deviceId,
            sensorType: this.$route.query.sensorType,
            fromDate: this.$route.query.fromDate,
            toDate: this.$route.query.toDate,
            fromTime: this.$route.query.fromTime,
            toTime: this.$route.query.toTime,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(jalali.now());
            //this.setdata(response.data.reportList, response.data.dateTime);
            this.setdata(
              response.data.reportData,
              jalali.now(),
              "",
              this.$route.query.sensorName
            );
          }
        });
    } else if (this.$route.query.whichReport == "dashboarReport") {
      var tempModel =
        this.$route.query.model.length == 0
          ? []
          : this.$route.query.model.split("!");
      //console.log(tempModel);
      // for (var i = 0; i < this.filterInfo.deviceModel.length; i++) {
      //   tempModel.push(this.filterInfo.deviceModel[i].value);
      // }

      var tempStatus =
        this.$route.query.status.length == 0
          ? []
          : this.$route.query.status.split("!");
      //console.log(tempStatus);
      // for (var i = 0; i < this.filterInfo.statusValue.length; i++) {
      //   tempStatus.push(this.filterInfo.statusValue[i].value);
      // }

      axios
        .post(Values.serverIp + "Report/GetCurrentSensorSituationReport", {
          onlineStatusIds: tempStatus,
          modelTypes: tempModel,
          organizationId:
            this.$route.query.organizationId == ""
              ? 0
              : this.$route.query.organizationId,
          searchText: this.$route.query.search,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            //this.setdata(response.data.reportList, response.data.dateTime);
            this.setdata(
              // response.data.reportList,
              // jalali.now(),
              // "",

              response.data.reportList[0],
              response.data.reportList[0].date +
                " " +
                response.data.reportList[0].time,
              "",
              ""
            );
          }
        });
    } else {
      console.log(this.$route.params.chartData);
      this.setdata(
        this.$route.params.chartData,
        this.$route.params.date,
        this.$route.params.sum
      );
    }

    //  else {
    //   console.log(this.$route.query.chartData);
    //   //this.setdata(this.$route.query.chartData, this.$route.query.date);
    // }
  },

  methods: {
    setdata(data, date, sum, name) {
      this.model = data;
      console.log(this.$route.query.whichReport);

      var report = Stimulsoft.Report.StiReport.createNewReport();
      if (this.$route.query.whichReport == "userList") {
        report.loadFile("/reports/userReport.mrt");
      } else if (this.$route.query.whichReport == "carList") {
        report.loadFile("/reports/carReport.mrt");
      } else if (this.$route.query.whichReport == "deviceList") {
        report.loadFile("/reports/deviceReport.mrt");
      } else if (this.$route.params.whichReport == "speedChart") {
        report.loadFile("/reports/chartReport.mrt");
      } else if (
        this.$route.params.whichReport == "dailyDistance" ||
        this.$route.params.whichReport == "monthlyDistance" ||
        this.$route.params.whichReport == "yearlyDistance"
      ) {
        report.loadFile("/reports/distanceReport.mrt");
      } else if (
        this.$route.params.whichReport == "dailySpeed" ||
        this.$route.params.whichReport == "exceedSpeed"
      ) {
        report.loadFile("/reports/dailySpeed.mrt");
      } else if (
        this.$route.params.whichReport == "dailyFuel" ||
        this.$route.params.whichReport == "monthlyFuel" ||
        this.$route.params.whichReport == "yearlyFuel"
      ) {
        report.loadFile("/reports/fuelConsuption.mrt");
      } else if (
        this.$route.query.whichReport == "sensorValue" ||
        this.$route.query.whichReport == "paramValue"
      ) {
        report.loadFile("/reports/sensorValuesReport.mrt");
      } else if (this.$route.query.whichReport == "dashboarReport") {
        report.loadFile("/reports/deviceReportDashboard.mrt");
      }

      var options = new Stimulsoft.Viewer.StiViewerOptions();
      var viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);

      //Activation with using license code
      Stimulsoft.Base.StiLicense.Key =
        "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHn0s4gy0Fr5YoUZ9V00Y0igCSFQzwEqYBh/N77k4f0fWXTHW5rqeBNLkaurJDenJ9o97TyqHs9HfvINK18Uwzsc/bG01Rq+x3H3Rf+g7AY92gvWmp7VA2Uxa30Q97f61siWz2dE5kdBVcCnSFzC6awE74JzDcJMj8OuxplqB1CYcpoPcOjKy1PiATlC3UsBaLEXsok1xxtRMQ283r282tkh8XQitsxtTczAJBxijuJNfziYhci2jResWXK51ygOOEbVAxmpflujkJ8oEVHkOA/CjX6bGx05pNZ6oSIu9H8deF94MyqIwcdeirCe60GbIQByQtLimfxbIZnO35X3fs/94av0ODfELqrQEpLrpU6FNeHttvlMc5UVrT4K+8lPbqR8Hq0PFWmFrbVIYSi7tAVFMMe2D1C59NWyLu3AkrD3No7YhLVh7LV0Tttr/8FrcZ8xirBPcMZCIGrRIesrHxOsZH2V8t/t0GXCnLLAWX+TNvdNXkB8cF2y9ZXf1enI064yE5dwMs2fQ0yOUG/xornE";

      var dataSet = new Stimulsoft.System.Data.DataSet("Demo");

      // Load report from url
      //report.loadFile("/reports/userReport.mrt");
      dataSet.readJson(this.model);

      report.regData(dataSet.dataSetName, "", dataSet);

      //برای مقادیر ثابت
      report.dictionary.variables.getByName("dateTime").valueObject = date;
      report.dictionary.variables.getByName("serverIp").valueObject =
        Values.serverIp;
      report.dictionary.variables.getByName("organizationName").valueObject =
        Values.companyName;

      if (
        this.$route.query.whichReport == "sensorValue" ||
        this.$route.query.whichReport == "paramValue"
      ) {
        report.dictionary.variables.getByName("name").valueObject = name;
      }

      if (
        this.$route.params.whichReport == "dailyFuel" ||
        this.$route.params.whichReport == "monthlyFuel" ||
        this.$route.params.whichReport == "yearlyFuel"
      ) {
        report.dictionary.variables.getByName(
          "totalDistanceSum"
        ).valueObject = `${sum[0]}`;
        report.dictionary.variables.getByName(
          "litterSum"
        ).valueObject = `${sum[1]}`;
      } else if (
        this.$route.params.whichReport == "dailyDistance" ||
        this.$route.params.whichReport == "monthlyDistance" ||
        this.$route.params.whichReport == "yearlyDistance"
      ) {
        report.dictionary.variables.getByName(
          "totalDistanceSum"
        ).valueObject = `${sum[0]}`;
      }

      // Assign report to the viewer, the report will be built automatically after rendering the viewer
      viewer.report = report;
      viewer.renderHtml("viewer");
    },
  },
};
</script>

<style>
</style>
